// Sidemenu.jsx
import React, { useState, useEffect } from 'react';
import DateTime from './datetime';
import { NavLink } from 'react-router-dom';
import Logout from './Logout';
import ThresholdModal from './ThresholdModal';
import { fetchAdminList } from '../../services/adminService';
import { decodeToken } from '../../utils/jwtUtils';

export default function Sidemenu() {
    const [showModal, setShowModal] = useState(false);
    const [currentAdmin, setCurrentAdmin] = useState(null);

    const token = localStorage.getItem("token");
    const user = token ? decodeToken(token) : null; // decodeToken 유틸 사용

    // 로그인한 관리자 정보 가져오기 (한 번만 호출)
    useEffect(() => {
        if (token && user?.username) {
            fetchAdminList(token)
                .then(list => {
                    const me = list.find(admin => admin.username === user.username);
                    setCurrentAdmin(me);
                })
                .catch(err => {
                    console.error("현재 로그인 관리자 정보 가져오기 실패:", err);
                });
        }
        // 빈 배열 [] → 컴포넌트 마운트 시 1회만 실행
    }, []);

    return (
        <div className="sidemenu">
            <div className="side_title">
                <p className="logo">
                    <img src="/media/logo.png" alt="곡성 스마트 안전지도 로고" />
                </p>
                <button className="map_search" onClick={() => setShowModal(true)}>
                    <img src="/media/left_seachicon.png" alt="설정" />
                </button>
                <DateTime />
            </div>

            <nav>
                <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'leftmenu01 active' : 'leftmenu01'}>대시보드</NavLink>
                <NavLink to="/map" className={({ isActive }) => isActive ? 'leftmenu02 active' : 'leftmenu02'}>스마트 지도</NavLink>
                <NavLink to="/user" className={({ isActive }) => isActive ? 'leftmenu03 active' : 'leftmenu03'}>사용자 관리</NavLink>
                <NavLink to="/device" className={({ isActive }) => isActive ? 'leftmenu04 active' : 'leftmenu04'}>장비 관리</NavLink>
                <NavLink to="/admin" className={({ isActive }) => isActive ? 'leftmenu05 active' : 'leftmenu05'}>관리자 관리</NavLink>
                <NavLink to="/log" className={({ isActive }) => isActive ? 'leftmenu06 active' : 'leftmenu06'}>로그 관리</NavLink>
                <NavLink to="/adminqna" className={({ isActive }) => isActive ? 'leftmenu07 active' : 'leftmenu07'}>문의사항</NavLink>
            </nav>

            {/* 로그인한 관리자 정보 표시 */}
             {currentAdmin && (
                <div className="current_admin_info">
                    <p>현재 접속자</p>
                    <ul>
                        <li>이름 - {currentAdmin.name || '-'}</li>
                        <li>소속 - {currentAdmin.department || '-'}</li>
                        <li>권한 - {currentAdmin.auth_name || '-'}</li>
                    </ul>
                </div>
            )}

            <div className='logoutwrp'>
                <Logout />
            </div>

            <div className='privacy_btn'>
                <NavLink to="/privacy">개인정보처리방침</NavLink>
            </div>

            {showModal && <ThresholdModal onClose={() => setShowModal(false)} />}
        </div>
    );
}
